export const FEATURE_FLAG_EXPERIMENT_COOKIE_NAME = 'x-flag-exp'
export const FEATURE_FLAG_INTERNAL_COOKIE_NAME = 'x-flag-internal'

export const flags = {
  FLAG_EXPEDITED_SHIPPING_DISABLED:
    'my-pga-com-jrl-expedited-shipping-disabled',
  FLAG_FEAT_GROUP_EVENT_RECURRING_PAYMENTS_ENABLED:
    'my-pga-com-feat-group-event-recurring-payments-enabled',
  FLAG_STUDENT_REVENUE_STAT: 'my-pga-com-student-revenue-statistic',
  FLAG_FEAT_ENFORCE_FCC: 'my-pga-com-enforce-fcc-preselect',
  FLAG_FEAT_BYPASS_JRL_REG: 'my-pga-com-jrl-registration-date-bypass',
  FLAG_FEAT_COACH_BUSINESS_INSIGHTS: 'my-pga-com-coach-business-insights',
  FLAG_FEAT_COACH_ANALYTICS: 'my-pga-com-feat-coach-analytics',
  FLAG_FEAT_COACH_LEAD_AUTO_REPLY: 'my-pga-com-coach-lead-auto-reply',
  FLAG_FEAT_REMOVE_PUBLIC_PRIVATE_FACILITY_CHECK:
    'my-pga-com-remove-public-private-facility-check',
  FLAG_FEAT_JRL_9U_DIVISION: 'my-pga-com-9u-division',
  FLAG_ACCOUNT_SETUP_PAYMENT_LINKS:
    'my-pga-com-stripe-account-setup-payment-links',
  FLAG_LESSON_PACK_PAYMENT_INTENTS: 'my-pga-com-lesson-pack-payment-intents',
  FLAG_PRACTICE_SESSIONS_PAYMENT_INTENTS:
    'my-pga-com-practice-sessions-payment-intents',
  FLAG_ADD_REMOVE_GROUP_CHANNEL_MEMBERS:
    'my-pga-com-add-remove-group-channel-members',
  FLAG_FAMILY_GOLF_REDIRECTS_ENABLED:
    'my-pga-com-family-golf-redirects-enabled',
  FLAG_GROUP_EVENT_PAYMENT_INTENTS: 'my-pga-com-group-event-payment-intents',
  FLAG_PRIVATE_BOOKING_PAYMENT_INTENTS:
    'my-pga-com-private-booking-payment-intents',
}
